<template>
    <div class="fin-container-fluid page-header">
        <div class="fin-flex fin-items-center fin-justify-between fin-py-6 md:fin-justify-start fin-h-[100px]">
            <div class="fin-flex fin-justify-start fin-flex-col lg:fin-w-0 lg:fin-flex-1 fin-max-w-[60%] lg:fin-max-w-auto">
                <div>
                    <img class="fin-h-auto fin-max-h-10 sm:fin-max-h-12 fin-w-auto" :src="core.logo" alt="" />
                </div>
                <div class="fin-block xl:fin-hidden">
                    <countdown
                        v-if="_.get(core, 'application.fast_track_active') && currentPageType !== 'welcome' && core.showCountdown"
                        :key="_.get(core, 'application.fast_track_active')"
                        :start-time="$moment.utc().format()"
                        :end-time="$moment.utc(_.get(core, 'application.fast_track_active')).format()"
                    >
                        <template v-slot:process="scope">
                            <strong class="fin-text-[10px] md:fin-text-xs">{{ `${scope.timeObj.m}` }} Minutes to Complete</strong>
                        </template>
                        <template v-slot:finish>
                            <strong style="color: #73bd44">Do you need more time?</strong>
                        </template>
                    </countdown>
                </div>
            </div>

            <div class="fin-ml-auto fin-text-right">
                <div class="xl:fin-hidden fin-items-center fin-justify-end fin-flex fin-flex-1">
                    <form-group-mobile></form-group-mobile>
                </div>
                <div class="fin-hidden xl:fin-block">
                    <countdown
                        v-if="_.get(core, 'application.fast_track_active') && currentPageType !== 'welcome' && core.showCountdown"
                        :key="_.get(core, 'application.fast_track_active')"
                        :start-time="$moment.utc().format()"
                        :end-time="$moment.utc(_.get(core, 'application.fast_track_active')).format()"
                        @finish="needMoreTime()"
                    >
                        <template v-slot:process="scope">
                            <strong class="fin-text-[10px] md:fin-text-xs">
                                {{ `${scope.timeObj.m}:${scope.timeObj.s}` }} minutes to complete
                            </strong>
                        </template>
                        <template v-slot:finish></template>
                    </countdown>
                </div>
            </div>
        </div>

        <x-modal
            :wWidth="600"
            v-if="requestMoreTimeModal.visible"
            @cancel="continueForm(false)"
            @close="continueForm(false)"
            @ok="continueForm(true)"
            :draggable="true"
            :resizable="true"
            :loading="false"
            :okDisabled="false"
            okText="Continue Now"
            :hideCancel="false"
            cancelText="Continue Later" 
        >
            <div slot="title" class="fin-flex fin-items-center fin-justify-between">Do you need more time?</div>

            <div>Do you need some more time to finish the application? You can complete the application anytime within 24 hours of starting, if you choose to continue later.</div>
        </x-modal>
    </div>
</template>

<script>
import formGroupMobile from "@tenant/app-form/components/form/formGroupMobile"
import vueAwesomeCountdown from "vue-awesome-countdown"
import { mapGetters } from "vuex"
import Modal from "@shared/components/modal/Modal.vue"

export default {
    name: "PageHeader",

    components: {
        formGroupMobile,
        vueAwesomeCountdown,
        "x-modal": Modal,
    },

    data() {
        return {
            requestMoreTimeModal: {
                visible: false,
            },
        }
    },

    computed: {
        ...mapGetters({
            core: "formStore/core/get",
            currentPageType: "formStore/form/currentPageType",
        }),
    },

    mounted() {},

    methods: {
        needMoreTime() {
            this.requestMoreTimeModal.visible = true
        },
        continueForm(continueForm) {
            axios
                .post(
                    `/app-form/${_.get(
                        this.$route,
                        "params.coreProp.applicant.id",
                        this.$route.params.applicant
                    )}/application/${_.get(this.$route, "params.coreProp.application.id", this.$route.params.application)}/${
                        this.$route.params.formType
                    }/continue-form`,
                    {
                        continueForm: continueForm
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${this.core.token}`
                        },
                    }
                )
                .then((res) => {

                    console.warn('res', res.data)
                    this.core.application.fast_track_active = res.data.fast_track_active
                    this.requestMoreTimeModal.visible = false

                    if (!continueForm) {
                        window.location.reload()
                    }
                })
        },
    },

    watch: {},
}
</script>

<style lang="scss" scoped></style>
